import { render, staticRenderFns } from "./youdian.vue?vue&type=template&id=52238308&"
import script from "./youdian.vue?vue&type=script&lang=js&"
export * from "./youdian.vue?vue&type=script&lang=js&"
import style0 from "./youdian.vue?vue&type=style&index=0&id=52238308&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports